import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "footer" }
const _hoisted_2 = { class: "width_wrap" }
const _hoisted_3 = { class: "footer_01" }
const _hoisted_4 = { class: "footer_info" }
const _hoisted_5 = { class: "navi_foot" }

import { ref, onMounted, onBeforeUnmount } from "vue";
import { USER_ROUTES } from "@/assets/route_constants.ts";


export default /*@__PURE__*/_defineComponent({
  __name: 'UserFooter',
  setup(__props) {

const isScrolled = ref(false);

// 스크롤 이벤트 핸들러
const handleScroll = () => {
  isScrolled.value = window.scrollY > 0;
};

// 최상단으로 스크롤
const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
};

// 라이프사이클 훅
onMounted(() => {
  window.addEventListener("scroll", handleScroll);
});

onBeforeUnmount(() => {
  window.removeEventListener("scroll", handleScroll);
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("a", {
        onClick: scrollToTop,
        id: "gotop",
        class: _normalizeClass({ on: isScrolled.value }),
        style: {"cursor":"pointer"}
      }, "TOP", 2),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("dl", null, [
            _createElementVNode("dt", null, [
              _cache[3] || (_cache[3] = _createElementVNode("h1", null, "주식회사 코코랩 COKOLab. Inc.", -1)),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("ul", null, [
                  _createElementVNode("li", null, [
                    _createVNode(_component_router_link, {
                      to: `${_unref(USER_ROUTES).About.Path}`
                    }, {
                      default: _withCtx(() => _cache[0] || (_cache[0] = [
                        _createTextVNode("연구소소개")
                      ])),
                      _: 1
                    }, 8, ["to"])
                  ]),
                  _createElementVNode("li", null, [
                    _createVNode(_component_router_link, {
                      to: `${_unref(USER_ROUTES).Privacy.Path}`
                    }, {
                      default: _withCtx(() => _cache[1] || (_cache[1] = [
                        _createTextVNode("개인정보처리방침")
                      ])),
                      _: 1
                    }, 8, ["to"])
                  ]),
                  _createElementVNode("li", null, [
                    _createVNode(_component_router_link, {
                      to: `${_unref(USER_ROUTES).Notice.Path}`
                    }, {
                      default: _withCtx(() => _cache[2] || (_cache[2] = [
                        _createTextVNode("커뮤니티")
                      ])),
                      _: 1
                    }, 8, ["to"])
                  ])
                ])
              ]),
              _cache[4] || (_cache[4] = _createStaticVNode("<div class=\"address\" data-v-c5be7608><ul data-v-c5be7608><li data-v-c5be7608>COKOLab. Inc.</li><li data-v-c5be7608> 주소 : 대전 유성구 엑스포로123번길 27-22 (도룡동) KCC 웰츠타워 101동 1107호 </li></ul><ul data-v-c5be7608><li data-v-c5be7608>사업자등록번호 : 214-87-42385</li><li data-v-c5be7608>통신판매업신고번호 : 2025-대전유성-0742</li></ul><ul data-v-c5be7608><li data-v-c5be7608>TEL. 042-867-5558</li><li data-v-c5be7608>FAX. 042-867-7228</li><li data-v-c5be7608>EMAIL : admin@cokolab.com</li></ul><ul data-v-c5be7608><li data-v-c5be7608>Copyright(c) COKOLab. Inc.. All Rights Reserved.</li></ul></div>", 1))
            ]),
            _createElementVNode("dd", null, [
              _cache[6] || (_cache[6] = _createElementVNode("h2", null, "오시는 길", -1)),
              _createVNode(_component_router_link, {
                to: `${_unref(USER_ROUTES).About.Map.Path}`
              }, {
                default: _withCtx(() => _cache[5] || (_cache[5] = [
                  _createTextVNode("지도보기 ")
                ])),
                _: 1
              }, 8, ["to"])
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})